<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26 2H0v24h26V2Z" fill="white" fill-opacity=".01" />
    <path
      d="M5.416 5c0-.552.485-1 1.084-1h15.166c.599 0 1.084.448 1.084 1v18c0 .552-.485 1-1.084 1H6.5c-.599 0-1.084-.448-1.084-1V5Z"
      :stroke="disabled ? disabledColor : color"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M18.416 5v18M3.25 9h4.333M3.25 14h4.333M3.25 19h4.333"
      :stroke="disabled ? disabledColor : color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.625 4h6.5M14.625 24h6.5"
      :stroke="disabled ? disabledColor : color"
      stroke-width="1.083"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class EnterIcon extends Vue {
  @Prop() disabled: boolean;
  @Prop({ type: String, default: '#FFFFFF' }) color: boolean;
  @Prop({ type: String, default: '#9FAAD2' }) disabledColor: boolean;
}
</script>
